<template>
  <div class="content">
    <p>
      Born and raised in New Delhi, I am a postgraduate in Computer Science from University College
      London (UCL). I enjoy designing and developing — breaking and optimising —
      all kinds of software, and I am particularly interested in Quantitative Engineering and large-scale data optimisation problems.
    </p>
    <p>
      <strong>Featured</strong>: 🔎
      <a href="https://chrome.google.com/webstore/detail/search-github/fbdfmneommmclhkndkhdagkcebgekkna?hl=en&authuser=1" target="_blank"
        >Search GitHub | Advanced Open Source Search</a
      >
    </p>
    <!--
    <p>
      Some lists and graphs to know more about me ..
    </p>
    <ul>
      <li><a href="#">Countries visited</a></li>
      <li><a href="#">Books and Movies</a></li>
      <li><a href="#">Hardware</a></li>
    </ul>
    -->
  </div>
</template>

<script>
  export default { name: 'About' }
</script>

<style scoped lang="scss">
  .content {
    a {
      color: inherit;

      &:hover {
        text-decoration: none;
      }
    }
  }
</style>
